export default {
  en: {
    commonDictionaries: 'Common dictionaries',
    myDictionaries: 'My dictionaries',
    tabsLabel: 'Dictionaries',
    wordsCount_one: '{{count}} word',
    wordsCount_other: '{{count}} words',
    topicsCount_one: '{{count}} topic',
    topicsCount_other: '{{count}} topics',
    levelTitle: 'Level',
    topicTitle: 'Topic',
    learnedOfTotal: 'learning/learned/total',
    loadingFilters: 'Loading filters',
  },
  ru: {
    commonDictionaries: 'Общие словари',
    myDictionaries: 'Мои словари',
    tabsLabel: 'Словари',
    wordsCount_one: '{{count}} слово',
    wordsCount_few: '{{count}} слова',
    wordsCount_many: '{{count}} слов',
    topicsCount_one: '{{count}} тема',
    topicsCount_few: '{{count}} темы',
    topicsCount_many: '{{count}} тем',
    levelTitle: 'Уровень',
    topicTitle: 'Тема',
    learnedOfTotal: 'учится/выучено/всего',
    loadingFilters: 'Загружаю фильтры',
  },
};
